import React, { useState, useContext } from 'react';
import { 
    Container, Row, Col
} from 'react-bootstrap';
import VerifyLogin from './VerifyLogin';
import Calendar from '../calendar/Calendar';
import PetSearch from '../search/PetSearch';
import CreateNewOwnerAndPet from '../create/CreateNewOwnerAndPet';
import CreateNewPet from '../create/CreateNewPet';
import JournalEntries from '../journal/JournalEntries';
import JournalOrCalendar from './JournalOrCalendar';
import AdminStateContext, { states } from '../contexts/AdminStateContext';

function Index(_) {

    const [selection, setSelection] = useState(null);
    const [clearSearch] = useState(false);
    const [state, setState] = useContext(AdminStateContext);

    return (
        <VerifyLogin children={
            <Container fluid>
                <Row className="justify-content-md-center">
                    <Col xs={0} md={2} />
                    <Col xs={12} md={8}>
                        <JournalOrCalendar
                            journalClicked={() => setState(states.SEARCH_PET)}
                            calendarClicked={() => setState(states.CALENDAR)}
                            shown={state === states.BUTTON_SELECT} />
                        <PetSearch 
                            allowCreate={true}
                            shown={state === states.SEARCH_PET}
                            onCreateNewOwner={(s) => { setSelection(s); setState(states.CREATE_NEW_OWNER); }}
                            onCreateNewPet={(s) => { setSelection(s); setState(states.CREATE_NEW_PET); }}
                            onGoToPetJournal={(s) => { setSelection(s); setState(states.JOURNAL_SHOWN); }}
                            clearSearch={clearSearch}/>
                        <CreateNewOwnerAndPet 
                            onSaved={(s) => { setSelection(s); setState(states.JOURNAL_SHOWN); }} 
                            shown={state === states.CREATE_NEW_OWNER} />
                        <CreateNewPet 
                            onSaved={(s) => { setSelection(s); setState(states.JOURNAL_SHOWN); }} 
                            ownerId={selection?.ownerId} 
                            shown={state === states.CREATE_NEW_PET} />
                        <JournalEntries 
                            shown={state === states.JOURNAL_SHOWN}
                            petId={selection?.petId} />
                        <Calendar
                            shown={state === states.CALENDAR}
                            petId={selection?.petId}
                            petName={selection?.petName} />
                    </Col>
                    <Col xs={0} md={2} />
                </Row>
            </Container>
        } />
    );

}

export default Index;